import { CropperTransitions, CropperImage, CropperState } from 'react-advanced-cropper'
import { getBackgroundStyle } from 'advanced-cropper'
import { AdjustableImage } from './AdjustableImage'
import React, { forwardRef } from 'react'

interface DesiredCropperRef {
  getState: () => CropperState
  getTransitions: () => CropperTransitions
  getImage: () => CropperImage
}

interface Props {
  className?: string
  cropper: DesiredCropperRef
  crossOrigin?: 'anonymous' | 'use-credentials' | boolean
  brightness?: number
  saturation?: number
  contrast?: number
  sepia?: number
  hue?: number
}

export const AdjustableCropperBackground = forwardRef<HTMLCanvasElement, Props>(({ className, cropper, crossOrigin, brightness = 0, saturation = 0, hue = 0, contrast = 0, sepia = 0 }, ref) => {
    const state = cropper.getState()
    const transitions = cropper.getTransitions()
    const image = cropper.getImage()

    const style = image && state ? getBackgroundStyle(image, state, transitions) : {}

    return (
      <AdjustableImage
        ref={ref}
        hue={hue}
        src={image?.src}
        className={className}
        crossOrigin={crossOrigin}
        brightness={brightness}
        saturation={saturation}
        contrast={contrast}
        sepia={sepia}
        style={style}
      />
    )
  }
)